var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkArrow = function SvgLinkArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.635 3.98c0-.57.465-1.019 1.048-1.019h9.995V1.203c0-.939.916-1.216 1.619-.688L17 3.305a.857.857 0 0 1 0 1.401l-3.703 2.777c-.73.555-1.62.225-1.62-.688V5.024H1.684A1.04 1.04 0 0 1 .635 3.979"
  })));
};
export default SvgLinkArrow;